import { render, staticRenderFns } from "./TvaAreaChart.vue?vue&type=template&id=81d1e278&scoped=true&"
import script from "./TvaAreaChart.vue?vue&type=script&lang=js&"
export * from "./TvaAreaChart.vue?vue&type=script&lang=js&"
import style0 from "./TvaAreaChart.vue?vue&type=style&index=0&id=81d1e278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d1e278",
  null
  
)

export default component.exports